// extracted by mini-css-extract-plugin
export default {"caffswitch":"Wy","lever":"Xy","toggle_rect":"Yy","toggle_rect_bundles":"Zy","switch":"az"};
    if(module.hot) {
      // 1713211524550
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  